<div class="border-b p-1 g-surface-quaternary shrink-0">
  <soft-ds-progress-steps
    [steps]="steps()"
    [currentIndex]="navTabIndex()"
    [allowJump]="true"
  ></soft-ds-progress-steps>
</div>

@if (creditNotice(); as notice) {
  <soft-ds-notification
    class="mx-2 mt-2"
    variant="inline"
    [status]="notice.status"
    [title]="notice.title"
    [dismissible]="false"
    data-testid="wizard-credit-limit-notice"
  >
    Offener Saldo
    {{ notice.balance | currency: 'EUR' : 'symbol' : '1.2-2' : 'de-AT' }}
    · {{ notice.thresholdLabel }}
    {{ notice.threshold | currency: 'EUR' : 'symbol' : '1.2-2' : 'de-AT' }}
  </soft-ds-notification>
}

<div class="px-2">
  @if (activeStep() === 'customer') {
    <soft-sales-customer-step
      [data]="documentData()"
      [isEmbedded]="true"
      (dataChange)="documentData.set($event)"
      (next)="onNext($event)"
      (create)="onCreate($event)"
    />
  }

  @if (activeStep() === 'address') {
    <soft-sales-address-step
      [data]="documentData()"
      [isEmbedded]="true"
      (dataChange)="documentData.set($event)"
      (next)="onNext($event)"
      (create)="onCreate($event)"
    />
  }

  @if (activeStep() === 'constructionSite') {
    <soft-sales-construction-site-step
      [data]="documentData()"
      [isEmbedded]="true"
      (dataChange)="documentData.set($event)"
      (next)="onNext($event)"
      (create)="onCreate($event)"
    />
  }

  @if (activeStep() === 'deliveryType') {
    <soft-sales-delivery-type-step
      [data]="documentData()"
      [isEmbedded]="true"
      (dataChange)="onDeliveryTypeChange($event)"
      (next)="onNext($event)"
      (create)="onCreate($event)"
    />
  }
</div>
